import { Button } from "flowbite-react";
import React from 'react';
import { Link } from "react-router-dom";
import { baseUrl } from '../config';



export function ScriptContent() {
  return (
    <div className='p-3'>
      <h3 className='font-bold pb-3'>Script Analysis</h3>
      <p>
        Detailed content about Script Analysis. This section covers the evaluation of the script, including structural analysis, character development, and plot evaluation. The script analysis might involve breaking down scenes, examining dialogue, and ensuring coherence throughout the script. A thorough script analysis helps identify strengths and weaknesses and prepares the script for production. This can include identifying key themes, character arcs, and plot devices that drive the story forward. The analysis may also involve collaborating with writers and directors to refine the script and make it production-ready.
      </p>
      <a href='#' className='text-blue-600 underline'>Learn more</a>
      <Link to='/input'><Button color='dark' className="mt-2">No thanks, take me to the page</Button></Link>
    </div>
  );
}
